import React from "react";
import { Controller } from "react-hook-form";
import "./index.scss";

const Checkbox = ({
  onInputChange = undefined,
  name = "",
  rules = {},
  required = true,
  disabled = false,
  control,
  errors,
  className = "",
  label = "",
  options = [],
  defaultValues = {},
  hideLabel = false,
}) => {
  return (
    <div>
      {label && <label className="checkbox-label">{label}</label>}
      <div className={`form-check ${className ? className : ""}`}>
        {options.map((option) => (
          <div key={option.entityid || option.name} className="form-check-item">
            <Controller
              name={option.name}
              control={control}
              rules={rules}
              defaultValue={option.checked}
              render={({ field: { onChange, onBlur, value } }) => {
                const isChecked = value === "yes";
                return (
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`checkbox_${option.entityid || option.name}`}
                    required={required}
                    disabled={disabled}
                    checked={isChecked}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      const newValue = checked ? "yes" : "no";
                      onChange(newValue);
                      if (onInputChange) {
                        onInputChange(option.name, checked);
                      }
                    }}
                    onBlur={onBlur}
                  />
                );
              }}
            />
            {!hideLabel && (
              <label
                className="form-check-label"
                htmlFor={`checkbox_${option.entityid || option.name}`}
              >
                {option.label || option.name}
              </label>
            )}
          </div>
        ))}
        {errors && errors[name] && (
          <div className="invalid-feedback">{errors[name]?.message}</div>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
